import { useEffect, useState } from 'react';
import './proceedingsForm.css';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { SquaredIcon } from '../components/squaredIcon';
import { ReactComponent as SaveProceedingSVG } from '../images/saveProceeding.svg';
import { ReactComponent as DeleteProceedingSVG } from '../images/trash.svg';
import { ReactComponent as LeftSvg } from '../images/left.svg';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../context/context';
import { get, post } from './utils/utils';

const animatedComponents = makeAnimated();

interface BranchesDocs {
  id?: string;
  idBranch: string;
  idDoc: string;
  doc: string;
}

export interface Proceeding {
  id?: string;
  internalNumber: string;
  courtNumber?: string;
  open?: string;
  close?: string;
  idStatus: string;
  idBranch?: string;
  idType: string;
  client?: string;
  starred?: boolean;
  phone?: string;
  mail?: string;
  implication?: string;
  description?: string;
  idCourt: string;
  signature?: string;
  notes?: string;
  /* address?: string; */
  idResolution: string | null;
}

interface ProceedingsFormProps {
  proceeding?: Proceeding;
}

export function ProceedingsForm({}: ProceedingsFormProps) {
  const { state }: { state: Proceeding } = useLocation();
  const [internalNumber, setInternalNumber] = useState<string>('');
  const [open, setOpen] = useState<string>('null');
  const [close, setClose] = useState<string>('null');
  const [idStatus, setIdStatus] = useState<string>('null');
  const [idType, setIdType] = useState<string>('null');
  const [description, setDescription] = useState<string>('');
  const [client, setClient] = useState<string>('');
  const [signature, setSignature] = useState<string>('');
  const [implication, setImplication] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [mail, setMail] = useState<string>('');
  const [notes, setNotes] = useState<string>('');
  const [idBranch, setIdBranch] = useState<string>();
  const [courtNumber, setCourtNumber] = useState<string>('');
  const [idCourt, setIdCourt] = useState<string>('null');
  const [status, setStatus] = useState([]);
  const [courts, setCourts] = useState([]);
  const [types, setTypes] = useState([]);
  const [resolutions, setResolutions] = useState([]);
  const [idResolution, setIdResolution] = useState<string>('null');
  const [branches, setBranches] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [branchesDocs, setBranchesDocs] = useState([]);
  let navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (state && state.id) {
      setInternalNumber(state.internalNumber);
      setIdStatus(state.idStatus);
      setIdType(state.idType);
      if (state.idBranch) setIdBranch(state.idBranch);
      setIdCourt(state.idCourt);
      if (state.open) setOpen(state.open);
      if (state.close) setClose(state.close);
      if (state.description) setDescription(state.description);
      if (state.client) setClient(state.client);
      if (state.signature) setSignature(state.signature);
      if (state.implication) setImplication(state.implication);
      if (state.phone) setPhone(state.phone);
      if (state.mail) setMail(state.mail);
      if (state.notes) setNotes(state.notes);
      if (state.courtNumber) setCourtNumber(state.courtNumber);

      const params = new URLSearchParams({ idProceeding: state.id });
      get({
        url: 'proceedingsDocs.php?' + params.toString(),
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          setSelectedDocs(
            data.map((doc: any) => ({
              idDoc: doc.idDoc,
              docName: doc.doc,
              idBranch: state.idBranch
            }))
          );
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
        });
    }
  }, []);

  useEffect(() => {
    if (idBranch) {
      const params = new URLSearchParams({ idBranch: idBranch });
      get({
        url: 'branchesDocs.php?' + params.toString(),
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          setBranchesDocs(data);
          //TODO
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
        });
    }
  }, [idBranch]);

  useEffect(() => {
    get({
      url: 'status.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        setStatus(data);
        if (state && state.idStatus) setIdStatus(state.idStatus);
        else setIdStatus(data[0].id);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  useEffect(() => {
    get({
      url: 'resolutions.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        setResolutions(data);
        if (state && state.idResolution) setIdResolution(state.idResolution);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  useEffect(() => {
    if (idBranch) {
      const params = new URLSearchParams({ idBranch: idBranch });
      get({
        url: 'types.php?' + params.toString(),
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          setTypes(data);
          if (state && state.idType) setIdType(state.idType);
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
        });
    }
  }, [idBranch]);

  useEffect(() => {
    get({
      url: 'branches.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        setBranches(data);
        if (state && state.idBranch) setIdBranch(state.idBranch);
        else setIdBranch(data[0].id);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  useEffect(() => {
    get({
      url: 'courts.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        setCourts(data);
      })
      .finally(() => {
        if (state && state.idCourt) setIdCourt(state.idCourt);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  function computeSelectedDocs(docs: any) {
    setSelectedDocs(
      docs.map((doc: any) => ({
        idDoc: doc.value,
        docName: doc.label,
        idBranch: idBranch
      }))
    );
  }

  function onSubmit(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    const proceeding: Proceeding = {
      internalNumber,
      open,
      idStatus,
      idType,
      description,
      client,
      implication,
      phone,
      mail,
      notes,
      idBranch,
      courtNumber,
      idCourt,
      close,
      idResolution,
      signature
      /* address, */
    };
    const formData = new FormData();
    formData.append('internalNumber', proceeding.internalNumber);
    formData.append('open', proceeding.open ?? 'null');
    formData.append('close', proceeding.close ?? 'null');
    formData.append('idStatus', proceeding.idStatus ?? 'null');
    formData.append('idType', proceeding.idType ?? 'null');
    formData.append('description', proceeding.description ?? '');
    formData.append('client', proceeding.client ?? '');
    formData.append('implication', proceeding.implication ?? '');
    formData.append('phone', proceeding.phone ?? '');
    formData.append('mail', proceeding.mail ?? '');
    formData.append('notes', proceeding.notes ?? '');
    formData.append('idBranch', proceeding.idBranch ?? 'null');
    formData.append('courtNumber', proceeding.courtNumber ?? '');
    formData.append('idCourt', proceeding.idCourt ?? 'null');
    formData.append('idResolution', proceeding.idResolution ?? 'null');
    formData.append('signature', proceeding.signature ?? '');
    formData.append(
      'docs',
      selectedDocs.length ? JSON.stringify(selectedDocs) : ''
    );
    if (state && state.id) {
      formData.append('id', state.id);
      post({
        url: 'putProceeding.php',
        data: formData,
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status === 'ok') {
            alert('Expediente modificado correctamente!');
          }
        })
        .catch((error) => {
          alert(error.response.data.error);
        });
    } else {
      post({
        url: 'postProceeding.php',
        data: formData,
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status === 'ok') {
            alert('Expediente agregado correctamente!');
            navigate('/expedientes');
          }
        })
        .catch((error) => {
          alert(error.response.data.error);
        });
    }
  }
  function onDelete() {
    if (state && state.id) {
      const formData = new FormData();
      formData.append('id', state.id);
      post({
        url: 'deleteProceeding.php',
        data: formData,
        token: user.token
      })
      .then((response) => response.data)
      .then((data) => {
        if (data.status === 'ok') {
          alert('Expediente eliminado correctamente!');
          navigate('/expedientes');
          }
        })
        .catch((error) => {
          alert(error.response.data.error);
        });
    }
  }

  return (
      <form className="proceedings-form" onSubmit={onSubmit}>
        <div className="proceedings-finish">
          <div className="clickable" onClick={() => navigate('/expedientes')}>
            <LeftSvg style={{ width: '20px', height: '20px' }} />
          </div>
          <div className="proceedings-submit">
            <p>Finalizar expediente</p>
            <button type="submit">
              <SquaredIcon icon={<SaveProceedingSVG className="clickable" />} />
            </button>
          </div>
        </div>
        <div className="proceedings-section-line"></div>
        <div className="proceedings-form-input-section">
          <label htmlFor="internalNumber">No.</label>
          <input
            className="proceedings-form-input flex-3"
            type="text"
            name="internalNumber"
            id="internalNumber"
            placeholder="Número interno"
            value={internalNumber}
            required
            onChange={(event) => setInternalNumber(event?.target.value)}
          />
          <select
            id="idCourt"
            name="idCourt"
            className="proceedings-form-input proceedings-form-select flex-3 max-width-35"
            onChange={(event) => setIdCourt(event.target.value)}
          >
            <option value="null">
              <strong>Juzgado</strong>
            </option>
            {courts.map((option: any) => (
              <option value={option.id} selected={idCourt == option.id}>
                <strong>{option.court}</strong>
              </option>
            ))}
          </select>
          <input
            className="proceedings-form-input flex-2"
            type="text"
            name="courtNumber"
            id="courtNumber"
            placeholder="No. Juzgado"
            value={courtNumber}
            onChange={(event) => setCourtNumber(event?.target.value)}
          />
        </div>
        <div className="proceedings-form-input-section">
          <label htmlFor="open">Fecha de apertura:</label>
          <input
            className="proceedings-form-input flex-3"
            type="date"
            name="open"
            id="open"
            placeholder="Fecha de apertura."
            value={open}
            onChange={(event) =>
              setOpen(new Date(event?.target.value).toISOString().split('T')[0])
            }
          />
          <label htmlFor="close" className="text-align-center">
            Fecha de cierre:
          </label>
          <input
            className="proceedings-form-input flex-3"
            type="date"
            name="close"
            id="close"
            placeholder="Fecha de apertura."
            value={close}
            onChange={(event) =>
              setClose(
                new Date(event?.target.value).toISOString().split('T')[0]
              )
            }
          />
        </div>
        <div className="proceedings-form-input-section">
          <label htmlFor="status">Estado del caso:</label>
          <select
            id="status"
            name="status"
            className="proceedings-form-input proceedings-form-select"
            onChange={(event) => setIdStatus(event.target.value)}
          >
            {status.map((option: any) => (
              <option value={option.id} selected={option.id == idStatus}>
                <strong>{option.name}</strong>
              </option>
            ))}
          </select>
          <label htmlFor="resolution" className="text-align-center">
            Resolución:
          </label>
          <select
            id="resolution"
            name="resolution"
            className="proceedings-form-input proceedings-form-select"
            onChange={(event) => {
              if (event.target.value) {
                setIdResolution(event.target.value);
              } else {
                setIdResolution('null');
              }
            }}
          >
            <option value="null">Resolución del caso</option>
            {resolutions.map((option: any) => (
              <option value={option.id} selected={option.id == idResolution}>
                <strong>{option.name}</strong>
              </option>
            ))}
          </select>
        </div>
        <div className="proceedings-form-input-section">
          <label htmlFor="type">Rama:</label>
          <select
            id="branch"
            name="branch"
            className="proceedings-form-input proceedings-form-select"
            onChange={(event) => {
              setIdBranch(event.target.value);
              setSelectedDocs([]);
            }}
          >
            {branches.map((branch: any) => (
              <option value={branch.id} selected={branch.id == idBranch}>
                <strong>{branch.branch}</strong>
              </option>
            ))}
          </select>

          <label htmlFor="type" className="text-align-center">
            Tipo de caso:
          </label>
          <select
            id="type"
            name="type"
            className="proceedings-form-input proceedings-form-select"
            onChange={(event) => setIdType(event.target.value)}
          >
            <option value="null">
              <strong>Tipo de caso</strong>
            </option>
            {types.map((type: any) => (
              <option value={type.id} selected={type.id == idType}>
                <strong>{type.type}</strong>
              </option>
            ))}
          </select>
        </div>
        <div className="proceedings-form-input-section">
          <label htmlFor="description">Descripción:</label>
          <textarea
            className="proceedings-form-input"
            id="description"
            name="description"
            placeholder="Descripción breve"
            value={description}
            onChange={(event) => setDescription(event?.target.value)}
          />
        </div>
        <div className="proceedings-section-line"></div>

        <div className="proceedings-form-input-section">
          <label htmlFor="client">Nombre:</label>
          <input
            className="proceedings-form-input"
            type="text"
            name="client"
            id="client"
            placeholder="Nombre completo del cliente"
            value={client}
            onChange={(event) => setClient(event?.target.value)}
          />
        </div>

        <div className="proceedings-form-input-section">
          <label htmlFor="implication">Implicación:</label>
          <input
            className="proceedings-form-input"
            type="text"
            name="implication"
            id="implication"
            placeholder="Demandante, demandado, apelante, etc."
            value={implication}
            onChange={(event) => setImplication(event?.target.value)}
          />
        </div>

        <div className="proceedings-form-input-section">
          <label htmlFor="phone">Contacto:</label>
          <input
            className="proceedings-form-input flex-2"
            type="text"
            name="phone"
            id="phone"
            placeholder="Tel."
            onChange={(event) => setPhone(event?.target.value)}
            value={phone}
          />
          {/* <input
          className="proceedings-form-input flex-3"
          type="text"
          name="address"
          id="address"
          placeholder="Dirección."
          value={address}
          onChange={(event) => setAddress(event?.target.value)}
        /> */}
          <input
            className="proceedings-form-input flex-2"
            type="text"
            name="email"
            id="email"
            placeholder="Correo electrónico"
            value={mail}
            onChange={(event) => setMail(event?.target.value)}
          />
        </div>

        <div className="proceedings-section-line"></div>

        <div className="proceedings-form-input-section">
          <label htmlFor="signature">Responsable:</label>
          <input
            className="proceedings-form-input"
            type="text"
            name="signature"
            id="signature"
            placeholder="Responsable"
            value={signature}
            onChange={(event) => setSignature(event?.target.value)}
          />
        </div>

        <div className="proceedings-form-input-section">
          <label htmlFor="notes">Notas:</label>
          <textarea
            className="proceedings-form-input"
            name="notes"
            id="notes"
            placeholder="Observaciones"
            value={notes}
            onChange={(event) => setNotes(event?.target.value)}
          />
        </div>

        <div className="proceedings-form-input-section">
          <label htmlFor="docs">Datos adjuntos:</label>
          {branchesDocs && (
            <Select
              className="proceedings-form-input"
              closeMenuOnSelect={false}
              components={animatedComponents}
              value={selectedDocs.map((selectedDoc: any) => ({
                value: selectedDoc.idDoc,
                label: selectedDoc.docName
              }))}
              isMulti
              options={branchesDocs.map((branch: BranchesDocs) => ({
                value: branch.idDoc,
                label: branch.doc
              }))}
              onChange={(val: any) => computeSelectedDocs(val)}
              placeholder="Documentos que se han entregado"
              menuPlacement="top"
            />
          )}
        </div>
        {state && state.id && <>
          <div className="proceedings-section-line"></div>
          <div className="proceedings-finish">
            <div className="proceedings-submit">
              <p>Eliminar expediente</p>
              <SquaredIcon icon={<DeleteProceedingSVG className="clickable" onClick={() => onDelete()} />} />
            </div>
          </div>
        </>}
      </form>
  );
}
